export const PORTFOLIO_DRAFTS_ROUTE = '/portfolios/drafts';
export const PORTFOLIO_CONTEXT_ROUTE = '/projects';
export const DESIRED_JOBS_CONTEXT_ROUTE = '/projects?tab=jobs';
